// extracted by mini-css-extract-plugin
export default {"mCard":"wB-z","image":"xB-z","imageNoBackground":"yB-z","imageHasCategory":"zB-z","fullWidth":"AB-z"};